import React, { useEffect, useMemo, useState } from "react";
import Header from "../../layout/Header";
import { fetchAPI } from "../../service/Encrtyption";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../loader";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { claimStatus, myRewards, reclaimDataSave, rewardMoney } from "../../auth/redux/store";
import ReactGA from 'react-ga4';
import { Button } from "react-bootstrap";
import Rewards from "../../../assets/images/Rewards.png"


export const BigRewardScreen = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();
    const currentLanguage = lang;
    const [formData, setFormData] = useState({});
    const [programName, setProgramName] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(false);
    const user = useSelector((state) => state?.user);
    const amount = useSelector((state) => state?.amount);
    const [errroMsg, setErrorMsg] = useState("");
    const browserType = sessionStorage.getItem("browserName") || "web";
    const location = useLocation();
    const mobileNumber = sessionStorage.getItem('mbn');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const scanResponseData = useSelector((state) => state?.genunityData);
    console.log(JSON.stringify(scanResponseData));

    const hide = () => {
        setErrorMsg("");
    };

    return (
        <>
            <Header />
            <div className="main">

                <div className="container">
                    {loading && <Loader />}

                    <div className="text-center mt-4">
                        <h5 className="card-title mb-0">{t('big_prize_opportunity_title')}</h5>
                        <p className="card-text mb-0">{t('big_prize_opportunity_desc')}</p>

                        <img src={Rewards} alt="Rewards" className="img-fluid my-4" />

                    </div>


                    <div className="d-flex flex-direction-column bottomBtns" style={{ gap: "1rem" }}>
                        <Button className="rounded-4 py-2 btnshadow btn-secondary mx-auto" style={{ width: "90%" }}
                            onClick={() => {

                                ReactGA.event({
                                    category: "Btn", 
                                    label: "User Scan More in BigReward Screen",
                                    action: "Clicked Scan More Button - BigReward Screen",
                                });
                                navigate(`/${lang}/scanProduct`);
                            }}>
                            {t("scan_more")}
                        </Button>

                        <Button className="rounded-4 py-2 btnshadow btn-secondary mx-auto" style={{ width: "90%" }} onClick={() => {

                            ReactGA.event({
                                category: "Btn",
                                label: "Proceed Button",
                                action: "Clicked Proceed Button - Big Reward Page",
                            });  
                            
                            if (scanResponseData.isSpinDone) {
                                navigate(`/${lang}/spinNotApplicable`);
                            } else {
                                navigate(`/${lang}/spinwheel`);
                            }
                        }}>
                            {t('rewardJourney.proceed')}
                        </Button>
                    </div>


                    {/* <div className="awardSummaryShareSection">
                        <button
                            type="button"
                            className="btn btn-primary bg-[#2BB24B] w-100 py-2 center-textbtn text-white claimBtn rounded-4 btnshadow"
                            onClick={() =>
                                navigate(`/${lang}/awardshare`)
                            }
                            id="shareRewardsBtn"
                        >
                            {t("Share")}
                        </button>
                    </div> */}


                    {errroMsg && (
                        <>
                            <div
                                className="alert alert-warning alert-dismissible fade show mt-2"
                                role="alert"
                            >
                                {errroMsg}
                                <button
                                    type="button"
                                    className="close"
                                    onClick={hide}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </>
                    )}


                </div>
            </div>
        </>
    );
};
